import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import UnsecuredPage from './UnsecuredPage';
import CmsDetailsState from './Context/CmsDetails/CmsDetailsSate';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    localStorage.setItem("azureData", JSON.stringify(event.payload.account));
    localStorage.setItem("token_type", event.payload.tokenType);
    localStorage.setItem("access_token", event.payload.accessToken);
    localStorage.setItem("profile_initial_credential",  event.payload.account.idTokenClaims.given_name.split("")[0] + event.payload.account.idTokenClaims.family_name.split("")[0]);
    localStorage.setItem("role_subaccount", (event.payload.account.idTokenClaims.department || event.payload.account.idTokenClaims.currentRole.toLowerCase().includes("cloud admin view")) ? true : false)
    localStorage.setItem("profile_name",  event.payload.account.idTokenClaims.given_name + " " + event.payload.account.idTokenClaims.family_name);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

msalInstance.initialize().then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
          <CmsDetailsState>
            {window.self === window.top ? <App/> : <UnsecuredPage />}
          </CmsDetailsState>
      </BrowserRouter>
    </MsalProvider>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

